export const DEFAULT_HEADERS = {
    "Ocp-Apim-Subscription-Key": process.env.REACT_APP_AZURE_SUBSCRIPTION_KEY
}